<template>
  <div id="app">
    <Menubar :model="leftMenu">
      <template #end>
        <a
          v-if="authStore.isAuthenticated"
          class="p-menuitem-link"
          @click="authStore.logout()"
        >
          <i class="pi pi-sign-out p-menuitem-icon"></i>
          <span class="p-menuitem-text">Logout</span>
        </a>
      </template>
    </Menubar>

    <Toast />
    <ConfirmDialog />
    <router-view />
  </div>
</template>

<script setup>
import { useAuthStore } from "@/stores/authStore";
import { computed } from "vue";
import { useRouter } from "vue-router";

const router = useRouter();
const authStore = useAuthStore();

const leftMenu = computed(() => {
  const items = [];

  if (authStore.isAuthenticated) {
    items.push({
      label: "Calendar",
      icon: "pi pi-fw pi-calendar",
      command: () => router.push("/"),
    });

    items.push({
      label: "Time Off",
      icon: "pi pi-fw pi-clock",
      command: () => router.push("/timeoff"),
    });

    if (authStore.isAdmin) {
      items.push({
        label: "Staff",
        icon: "pi pi-fw pi-users",
        command: () => router.push("/staff"),
      });

      items.push({
        label: "Stores",
        icon: "pi pi-fw pi-building",
        command: () => router.push("/stores"),
      });

      items.push({
        label: "Holiday Hours",
        icon: "pi pi-fw pi-calendar-times",
        command: () => router.push("/holiday-hours"),
      });

      items.push({
        label: "Admin Tools",
        icon: "pi pi-fw pi-cog",
        command: () => router.push("/admin-tools"),
      });
    }
  } else {
    items.push({
      label: "Login",
      icon: "pi pi-fw pi-sign-in",
      command: () => router.push("/login"),
    });
  }

  return items;
});
</script>

<style>
/* Optional spacing tweak if Logout button appears cramped */
.p-menubar-end .p-menuitem-link {
  margin-left: 1rem;
}
</style>
